import React, { FC } from 'react';

import { BrandLogo } from 'src/components/Header/BrandLogo';
import { UiButton } from 'src/components/UI/Button';
import { BrandingModelSelectorType } from 'src/models/Branding/BrandingModel';
import { IconChevronLeft } from './icons/ChevronLeft';
import styles from './styles.module.scss';

type Props = {
  onClose: () => void;
  brandingModel: BrandingModelSelectorType;
  hideRallyUpLogo?: boolean;
};

export const Header: FC<Props> = ({ onClose, hideRallyUpLogo, brandingModel }) => (
  <div className={styles.header}>
    <BrandLogo brandingModel={brandingModel} hideRallyUpLogo={hideRallyUpLogo} className={styles.logo} noClassImage />

    <UiButton className={styles.closeBtn} onClick={onClose} dataTestId="toggleIconLeftMenu">
      <IconChevronLeft className={styles.icon} />
    </UiButton>
  </div>
);
